import URLFactory from './url';
import { Cancellable } from './abortable-call';
import { CacheableURL, URLParams } from './types';
import { AxiosRequest } from '.';

/**
 * ### HttpCacheableRequest Module
 *
 * Provide an API for `Cancel` and for `Cache`
 * requests associated to a given `url`.
 *
 * @author <pino0071@gmail.com> Jose Aburto
 * @version v1
 */
export abstract class HttpCacheableRequest extends Cancellable {
  protected buildURL(url: string, params?: URLParams): CacheableURL {
    return URLFactory.createCacheableURL().buildURL(url, params);
  }
  protected expireEndpoint(url: string): void {
    AxiosRequest.expireEnpoint(url);
  }
}
